import * as DropdownMenu from '~/sotano-kit/primitives/dropdown-menu'
import { CommentAction } from './get-comment-actions'
import { clsx } from 'clsx'

import { useToggleState } from '~/hooks/use-toggle-state'

export const ActionsMenuComment = ({
  actions,
  toggleState,
  children,
}: {
  actions?: CommentAction[] | null
  toggleState: ReturnType<typeof useToggleState>
  children?: React.ReactNode
}) => {
  return (
    actions && (
      <DropdownMenu.DropdownMenu
        modal={false}
        onOpenChange={toggleState.handleToggle}
        open={toggleState?.isOn}
      >
        <DropdownMenu.DropdownMenuTrigger
          asChild
          onClick={(e) => e.stopPropagation()}
        >
          {children}
        </DropdownMenu.DropdownMenuTrigger>
        <DropdownMenu.DropdownMenuContent
          align="end"
          side="bottom"
          onCloseAutoFocus={(e) => e.preventDefault()}
          data-inner-popover
          className="shadow-modal z-[90]"
        >
          {actions.map((action) => (
            <DropdownMenu.DropdownMenuItem
              key={action.label}
              onClick={action.action}
              className={clsx(
                'flex gap-1 items-center p-2 w-full text-sm',
                action.isDestructive ? 'text-dark-error' : 'text-dark-dim'
              )}
            >
              {action.icon}
              <span>{action.label}</span>
            </DropdownMenu.DropdownMenuItem>
          ))}
        </DropdownMenu.DropdownMenuContent>
      </DropdownMenu.DropdownMenu>
    )
  )
}
